import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  scrollMain: {
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
    overflow: "auto",

    "& .MuiPaper-root": {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column"
    }
  },
  main: {
    width: "100%",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: 0,

    "& .MuiPaper-root": {
      flex: 1,
      minHeight: 0,
      display: "flex",
      flexDirection: "column"
    }
  },
  paperMain: {
    minHeight: "60vh",
    display: "flex",
    padding: "0",
    margin: "15px 0"
  },
  tableTop: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 35,
    marginBottom: theme.spacing(2),
    marginTop: -8
    // position: "-webkit-sticky",
    // position: "sticky",
    // top: -10
  },
  searchAction: {
    position: "absolute",
    right: 0,
    top: 0,
    marginTop: -1 * theme.spacing(6)
  },
  rightAction: {
    display: "flex",

    "& .MuiButton-root": {
      marginLeft: theme.spacing(2)
    }
  },
  subTitle: {
    marginLeft: theme.spacing(2),

    "& .app-icon": {
      marginRight: 5
    }
  },
  tableQueryForm: {
    display: "flex",
    flexWrap: "wrap",

    "& .ui-form-item": {
      marginBottom: 12
    }
  },
  tableWrap: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  queryKeyword: {
    marginBottom: 5
  },
  tableAction: {
    display: "inline-flex !important",
    alignItems: "center !important",
    // position: "absolute",
    zIndex: "4 !important",
    // top: "-55px",
    // right: 0,
    marginBottom: theme.spacing(2),
    "& svg": {
      marginBottom: "0 !important",
      top: "0 !important",
      marginLeft: "10px !important"
    }
  },
  tableTitle: {
    display: "flex"
  },
  tableTitleTag: {
    display: "inline-flex !important",
    alignItems: "center !important",
    padding: "20px 5px",
    "& svg": {
      marginLeft: "10px !important"
    }
  },
  icon_btn: {
    cursor: "pointer"
  },
  listItem: {
    borderTop: "1px solid #e0e0e0",
    "&:nth-child(odd)": {
      backgroundColor: "#f3f3f3"
    },
    "&:last-child": {
      borderBottom: "1px solid #e0e0e0"
    },
    "&:hover": {
      backgroundColor: "#e0e0e0"
    }
  },
  listHeader: {
    margin: "10px 0 5px 92px !important"
  },
  listIcon: {
    marginLeft: "20px"
  },
  bottom: {
    marginLeft: "37px",
    marginTop: "20px"
  },
  titleButton: {
    color: "#333333",
    backgroundColor: "#fff",
    borderRadius: 6,
    padding: "10px 32px",
    marginRight: 32,
    cursor: "pointer"
  },
  selectedTitleButton: {
    color: "#00AFC6",
    backgroundColor: "#E5F7F9",
    borderRadius: 6,
    padding: "10px 32px",
    marginRight: 32,
    cursor: "pointer"
  }
}));

export default useStyles;
